export const contentMediaTypes = [
  //   Video:
  {
    extensions: ["avi", "mp4", "mpg", "mov", "wmv", "mp3", "m4a"],
    mediaType: 1,
    type: "Video",
    text: "Video",
  },
  //   Youtube:
  { extensions: [""], mediaType: 2, type: "YouTube", text: "YouTube Video" },
  //   Ppt:
  { extensions: ["ppt", "pptx"], mediaType: 3, type: "PPT", text: "Document" },
  //   O365Video:
  { extensions: [""], mediaType: 4, type: "O365Video", text: "Video" },
  //   Slideshare:
  {
    extensions: [""],
    mediaType: 5,
    type: "SlideShare",
    text: "SlideShare",
  },
  //   OneDrive:
  { extensions: [], mediaType: 6, type: "OneDrive", text: "Document" },
  //   Pdf:
  { extensions: ["pdf"], mediaType: 7, type: "PDF", text: "Document" },
  //   MOOC:
  {
    extensions: [""],
    mediaType: 8,
    type: "Online Course",
    text: "Online Course",
  },
  //   SCORM:
  { extensions: [""], mediaType: 9, type: "SCORM", text: "SCORM" },
  //   Image:
  { extensions: [""], mediaType: 10, type: "Image", text: "Image" },
  //   HTML5:
  { extensions: [""], mediaType: 11, type: "HTML", text: "HTML" },
];
